import { render, staticRenderFns } from "./DaysConfirmedWidget.vue?vue&type=template&id=525cf2f8&scoped=true&"
import script from "./DaysConfirmedWidget.vue?vue&type=script&lang=js&"
export * from "./DaysConfirmedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525cf2f8",
  null
  
)

export default component.exports